import AppConfig from '../app-config';
import { useLayoutEffect } from 'react';

/**
 * Use this in a page component where you want to remove padding
 * from the body of the page.
 *
 * NOTE: This component cannot be used more than once in the entire page.
 *
 * #### Example
 * ```tsx
 * const MyPage = () => {
 *   return <>
 *     <AppNoBodyPadding />
 *     <AppTitle>MyPage</AppTitle>
 *  </>
 * }
 * ```
 */
export const AppNoBodyPadding = () => {
  const { setConfig } = AppConfig.useSetter();
  useLayoutEffect(
    () => {
      setConfig(c => (c.noPagePadding ? c : { ...c, noPagePadding: true }));
      return () => setConfig(c => (!c.noPagePadding ? c : { ...c, noPagePadding: false }));
    },
    []
    /* Add for multiple instances of component support: [config.noPagePadding] */
  );
  return null;
};
